import axiosInstance from "../../utils/axiosConfig";
import React, { useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { toast } from "react-hot-toast";
import { API_URL } from "../../constant";

type MakeOtcTraderModalProps = {
  open: boolean;
  onClose: () => void;
  userId: string;
  userName?: string;
  onSuccess?: () => void;
};

const MakeOtcTraderModal = ({
  open,
  onClose,
  userId,
  userName,
  onSuccess,
}: MakeOtcTraderModalProps) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!userId || loading) return;
    setLoading(true);
    axiosInstance
      .patch(`${API_URL}api/admin/otc/users/${userId}`, {
        enabled: true,
        autoPayoutEnabled: true,
      })
      .then(() => {
        toast.success("User is now an OTC trader");
        onSuccess?.();
        onClose();
      })
      .catch((e: any) => {
        const msg = e.response?.data?.message || "Failed to make OTC trader";
        toast.error(msg);
      })
      .finally(() => setLoading(false));
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex font-manrope justify-center items-center overflow-auto p-4 bg-black bg-opacity-80 backdrop-blur-sm z-50">
      <div className="w-full max-w-md rounded-xl bg-[#1F1F1F] p-6 shadow-xl">
        <div className="flex justify-between items-center mb-4">
          <h4 className="font-bold text-[20px] font-sora text-white">
            Make OTC trader
          </h4>
          <button
            type="button"
            onClick={onClose}
            className="text-[#78C2F7] text-[14px] font-medium cursor-pointer hover:underline"
          >
            Close
          </button>
        </div>
        <p className="text-[#A0A9AD] text-[14px] mb-6">
          {userName
            ? `${userName} will be able to use OTC trading with auto-payout enabled.`
            : "This user will be able to use OTC trading with auto-payout enabled."}
        </p>
        <form onSubmit={handleSubmit} className="flex gap-3 w-full">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 h-[46px] flex justify-center items-center font-manrope font-medium rounded-xl text-secondary_button bg-transparent border border-secondary_button"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="flex-1 h-[46px] flex justify-center items-center font-manrope font-medium rounded-xl text-white bg-[#095B97] hover:bg-[#0A6AAF] disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {loading ? (
              <TailSpin color="#fff" height={24} width={24} />
            ) : (
              "Make OTC trader"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default MakeOtcTraderModal;
